/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIDatasetExportRequest
 */
export interface AIDatasetExportRequest {
    /**
     * 
     * @type {string}
     * @memberof AIDatasetExportRequest
     */
    path: string;
}

export function AIDatasetExportRequestFromJSON(json: any): AIDatasetExportRequest {
    return AIDatasetExportRequestFromJSONTyped(json, false);
}

export function AIDatasetExportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIDatasetExportRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
    };
}

export function AIDatasetExportRequestToJSON(value?: AIDatasetExportRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
    };
}


